import React, {useMemo} from 'react';
import {useProjectTelReportsByOfficeNumberRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();

  const {data: {projectTelReportsByOfficeNumberRange = []} = {}} =
    useProjectTelReportsByOfficeNumberRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectTelReportsByOfficeNumberRange.map((report) => {
        return {
          name: report.officeNumberRange,
          callCount: report.callCount,
          contactCount: report.contactCount,
          contactCallRate: report.contactCallRate,
          documentCount: report.documentCount,
          documentCallRate: report.documentCallRate,
          appointCount: report.appointCount,
          appointCallRate: report.appointCallRate,
        };
      }),
    [projectTelReportsByOfficeNumberRange],
  );

  return <Table data={data} />;
};
